import React, { Component } from "react"
import PropTypes from "prop-types"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux"
import { Link, withRouter, BrowserRouter as Router, NavLink as RouterNavLink } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getProjectStatus, getAllProjectAction, deleteProject, getSearchAllProject, updateProjectStatus, addBuilder } from "../../../store/actions"
import DeleteModal from "../../../components/Common/DeleteModal";
import ProjectMenu from "./menu/all-project"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { MultiSelect } from 'primereact/multiselect';
import gridView from "../../../assets/img/grid-view.png"
import engagementView from "../../../assets/img/engagement-view.png"
import plusIcon from "../../../assets/img/plus-symbol-button.png"
import {
  Col,
  Container,
  Row,
  Table,
  Card,
  CardBody,
  Input,
  CardTitle,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Button,
  CardHeader,
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { map } from "lodash"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RsCard from "components/Rscards/Rscard";
import RSBarChart from "components/charts/RSBarChart";
import RsLink from "components/buttons/rsLink";
import ProjectStatusGridOption from "components/dropdowns/project/ProjectStatus-grid";
import { API_URL } from "helpers/app_url";
import { addProject, getProjectUUIDAction, projectUpdate } from "../../../store/projects/actions"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { BlobServiceClient } from '@azure/storage-blob';
import CurrencyDropdown from "components/dropdowns/Other/CurrencyDropdowns";
import SaveButton from "components/buttons/save";
import ProjectStatusOption from "components/dropdowns/project/ProjectStatus";
import axios from "axios";
import Moment from "react-moment";
import { act } from "react";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import RsCardImgv2 from "components/Rscards/Rscard-imgv2";
import projectIcon from "../../../assets/img/project-icon.png";
import clientIcon from "../../../assets/img/user-icon.png";
import leadIcon from "../../../assets/img/l-1.png";
import leadConversion from "../../../assets/img/conversion-icon.png";
import ProjectDashboardBreadcrumb from "components/Common/ProjectDashboardBreadcrumb";
import { ColumnGroup } from 'primereact/columngroup';
import { Row as ColumnGroupRow } from 'primereact/row';
import RsCardImgv4 from "components/Rscards/Rscard-imgv4";
import { azureConfig } from "helpers/azureConfig";
import Swal from "sweetalert2";
import SafeField from "helpers/SafeField";
import { hasPermission } from "helpers/checkPermission";
class ProjectsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      project: '',
      activePeriod: 'Today',
      activePeriod2: 'Today',
      checked: false,
      complitionYear: '',
      city: '',
      strintingPrice: '',
      status: '',
      projectTypes: [],
      builders: [],
      projectStatus: [],
      file: null,
      selectedCurrency: {
        code: 'USD',
        symbol: '$',
        format: 'USD',
      },
      totalProject: 0,
      totalClient: 0,
      totalLead: 0,
      totalLeadtoClient: 0,
      filtered: [],
      modal: false,
      projects: this.props.projects,
      filteredProjects: this.props.projects,
      searchQuery: "",
      selectedStatus: "0",
      projectMonths: [],
      cityData: [],
      projectLead: [],
      projectLeadClient: [],
      projectCounts: [],
      projectMonthNames: [],
      projecttopfive: [],
      lead5: [],
      activity5: [],
      expandedLead: null,
      expandedActivity: null,
      expandedRows: null,
    }

    this.onClickDelete = this.onClickDelete.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleAddNew = this.toggleAddNew.bind(this);
    this.handleProjectSubmit = this.handleProjectSubmit.bind(this)
    this.toggleNewBuilder = this.toggleNewBuilder.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
  }
  addNewtoggle() {
    this.setState(prevState => ({
      isAddNew: !prevState.isAddNew
    }));
  }
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });

  }
  async handleFileChange(event, setFieldValue) {
    const file = event.currentTarget.files[0];
    if (file) {
      const maxSize = 2 * 1024 * 1024;
      const allowedTypes = ['image/jpeg', 'image/png'];
      const allowedExtensions = ['.jpg', '.jpeg', '.png'];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
      if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          title: 'File type or extension not allowed',
          text: 'Please upload a JPG, or PNG file.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
        return;
      }
      if (file.size > maxSize) {
        Swal.fire({
          title: 'Size not allowed',
          text: 'Please Upload Maximum 2MB File',
          icon: 'warning',
          confirmButtonText: 'OK',
        });

      }
      const sasToken = azureConfig.sasToken;
      const containerName = azureConfig.containerName;
      const storageAccountName = azureConfig.storageAccountName;
      const fileName = `${Date.now()}_${file.name}`;
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      try {
        await blobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type }
        });

        //alert('File uploaded successfully!');
        if (setFieldValue) {
          const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
          setFieldValue(`builderLogo`, fileUrl);

        }
      } catch (error) {
        console.error('Error uploading file:', error);

      }
    }
  }
  handleBuilderPlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        const modifiedAddress = `${streetNumber} ${route}`;



        setFieldValue('fullAddress', place.formatted_address);
        setFieldValue('addressLine1', modifiedAddress);
        setFieldValue('addressLine2', '');
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue('longitude', longitude);
        setFieldValue('latitude', latitude);
      })
      .catch(error => console.error('Error', error));
  };
  builderToggle() {
    this.setState(prevState => ({
      isNewBuilder: !prevState.isNewBuilder
    }));
  }
  toggleNewBuilder() {
    this.setState({ isNewBuilder: !this.state.isNewBuilder });

  }
  handleValidSubmit(value) {
    this.props.addBuilder(value, (status) => {
      if (status == true) {
        this.builderToggle();
        this.fetchBuilder();
      }
    })
  }
  handleProjectSubmit(value) {
    this.props.addProject(value, this.props.history);
    this.addNewtoggle();
  }
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };

  handleComplitionYear = (event) => {
    this.setState({ complitionYear: event.target.value });
  };

  handleCityChange = (event) => {
    this.setState({ city: event.target.value });
  };

  handlePriceChange = (event) => {
    this.setState({ strintingPrice: event.target.value });
  };
  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };


  componentDidMount() {
    const { onGetAllProject, onGetSearchAllProject, onGetProjectStatus } = this.props;

    onGetAllProject(localStorage.getItem('userId'), localStorage.getItem('brokerId'));
    onGetProjectStatus(localStorage.getItem('userId'));
    this.fetchNewLead(1, 'Today');
    this.fetchNewActivity(1, 'Today');
    this.fetchBuilder();
     const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
      axios.get(`${API_URL}ProjectType/allforagent`, {
        params: {
          agentId: parseInt(localStorage.getItem('userId'))
        }, headers: { Authorization: str }
      })
        .then(res => {
          const projectTypes = res.data;
          this.setState({ projectTypes });
        }),
      axios.get(`${API_URL}ProjectExt/getProjectCountByAgent`, {
        params: {
          agentId: localStorage.getItem("userId"),
        }, headers: { Authorization: str }
      })
        .then(res => {

          this.setState({ totalProject: res.data.countProject, totalClient: res.data.countProjectClient, totalLead: res.data.countProjectLead, totalLeadtoClient: res.data.countProjectLeadtoClient });
        });


    axios.get(`${API_URL}ProjectExt/getProjectTopFiveProjectsByAgent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ projecttopfive: res.data });
      });

    axios.get(`${API_URL}ProjectExt/getProjectCitiesDistributionByAgent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ cityData: res.data });
      });

    axios.get(`${API_URL}ProjectCampaignLead/allforagent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ lead5: res.data });
      })

    axios.get(`${API_URL}ProjectCampaignLeadActivities/allforagent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ activity5: res.data });
      });

    axios.get(`${API_URL}ProjectExt/getProjectLunchMonthByAgent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ projectMonthNames: res.data.months, projectCounts: res.data.counts });
      });


  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (project) => {
    this.setState({ project: project });
    this.setState({ deleteModal: true });
  };

  handleDeleteProject = () => {
    const { onDeleteProject } = this.props;
    const { project } = this.state;
    //
    if (project.id !== undefined) {
      onDeleteProject(project.id);
      this.setState({ deleteModal: false });
    }
  };
  handleChange(e) {
    var value = e.target.value;
    this.setState({
      searchString: value,
      filtered: this.state.data.filter(e =>
        Object.values(e)
          .join(" ")
          .toLowerCase()
          .match(value)
      )
    });
  }
  handleSearchSubmit = (event) => {
    event.preventDefault();



  };

  handleChangeStaus = arg => {
    const project = arg;
    const { onUpdateStatus } = this.props;
    const updateSt = {
      id: project.id,
      isActive: (project.isActive == true) ? false : true,
    }
    onUpdateStatus(updateSt);
  }
  handleStatusChange = async (projectId, projectStatus) => {
    const payload = {
      id: projectId,
      agentId: parseInt(localStorage.getItem('userId')),
      projectStatus: parseInt(projectStatus),
    };

    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const response = await fetch(API_URL + '/Project/updateprojectcurrentstatus', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        toast.loading("Please wait...")
        toast.dismiss();
        toast.success("Status updated successfully!");
        this.props.onGetAllProject(localStorage.getItem('userId'), localStorage.getItem('brokerId'));
        //

      } else {
        console.error('Failed to update status:', response.statusText);
      }
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value.toLowerCase() }, this.applyFilters);
  };

  handleStatusFilter = (e) => {
    this.setState({ selectedStatus: e.target.value }, this.applyFilters);
  };

  applyFilters = () => {
    const { projects, searchQuery, selectedStatus } = this.state;

    const filteredProjects = projects.filter((project) => {
      const matchesSearch =
        !searchQuery ||
        project.projectName?.toLowerCase().includes(searchQuery) ||
        project.city?.toLowerCase().includes(searchQuery) ||
        project.builder?.toLowerCase().includes(searchQuery);

      const matchesStatus =
        selectedStatus === "0" || project.projectStatus?.toString() === selectedStatus;

      return matchesSearch && matchesStatus;
    });

    this.setState({ filteredProjects });
  };
  componentDidUpdate(prevProps) {
    if (prevProps.projects !== this.props.projects) {
      this.setState({
        projects: this.props.projects,
        filteredProjects: this.props.projects
      });
    }
  }


  fetchNewActivity(days, periodLabel) {
    this.setState({ loading: true, activePeriod2: periodLabel });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      agentId: localStorage.getItem("userId"),
      day: days,
    };
    axios
      .get(`${API_URL}ProjectExt/getProjectActivityForDashboardByDay`, { headers, params })
      .then((response) => {
        this.setState({ newActivity: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchNewLead(days, periodLabel) {
    this.setState({ loading: true, activePeriod: periodLabel });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      agentId: localStorage.getItem("userId"),
      day: days,
    };
    axios
      .get(`${API_URL}ProjectExt/getProjectCampaignLeadForDashboardByDay`, { headers, params })
      .then((response) => {
        this.setState({ newLeads: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  toggleLeadExpand = (key) => {
    this.setState({ expandedLead: this.state.expandedLead === key ? null : key });
  };

  toggleLeadActivity = (key) => {
    this.setState({ expandedActivity: this.state.expandedActivity === key ? null : key });
  };
  fetchBuilder(){
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;

    axios.get(`${API_URL}BuilderExt/allforagent`, {
      params: {
        agentId: parseInt(localStorage.getItem('userId'))
      }, headers: { Authorization: str }
    })
      .then(res => {
        const builders = res.data;
        this.setState({ builders });
      });
  }
  render() {

    const headerGroup = (
      <ColumnGroup>
        <ColumnGroupRow>
          <Column header="#" rowSpan={2} />
          <Column header="Project Name" rowSpan={2} />
          <Column header="# Leads" rowSpan={2} />
          <Column header="Worksheets" colSpan={2} headerClassName="worksheet-header" />
          <Column header="# Clients" rowSpan={2} />
          <Column header="Status" rowSpan={2} />
          <Column header="Action" rowSpan={2} />
        </ColumnGroupRow>
        <ColumnGroupRow>
          <Column header="Pending" headerClassName="worksheet-subheader" />
          <Column header="Submitted" headerClassName="worksheet-subheader" />
        </ColumnGroupRow>
      </ColumnGroup>
    );


    const { projects, docstatuses, isResponsive } = this.props;
    const { deleteModal, expandedLead, expandedActivity } = this.state;
    const userModule = localStorage.getItem('userModule');
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { activePeriod, activePeriod2, filteredProjects, lead5, activity5, searchQuery, newLeads, newActivity, selectedStatus, totalProject, totalClient, totalLead, totalLeadtoClient, projectCounts, projectMonthNames, projectLeadClient, projectLead, projectMonths, projecttopfive, cityData } = this.state;
    const leadData5 = lead5.length > 5 ? lead5.slice(0, 5) : lead5;
    const activityData5 = activity5.length > 5 ? activity5.slice(0, 5) : activity5;
    //
    const reports = [
      { title: "# Active projects", iconClass: projectIcon, description: totalProject },
      {
        title: "# Clients",
        iconClass: clientIcon,
        description: totalClient,
      },
      {
        title: "# Leads",
        iconClass: leadIcon,
        description: totalLead,
      },
      {
        title: "Leads to client conversion",
        iconClass: leadConversion,
        description: totalLeadtoClient + "%",
      },

    ];

    const barchartdata = {
      series: [
        {

          data: projectCounts,
        }
      ],
      options: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },

        grid: {
          borderColor: "#f1f1f1",
        },
        colors: ["#195772"],
        xaxis: {
          categories: projectMonthNames,
        },
      },
    };
    const cityNames = cityData.map(item => item.city);
    const cityCounts = cityData.map(item => item.count);
    const CityBardata = {
      series: [
        {
          //name: "Projects",
          data: cityCounts,
        }
      ],
      options: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },

        grid: {
          borderColor: "#f1f1f1",
        },
        colors: ["#195772"],
        xaxis: {
          categories: cityNames,
        },
      },
    };

    return (
      <React.Fragment>
        {/* {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null} */}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteProject}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Projects | Realty Space</title>
          </MetaTags>
          <Container fluid className="">
            {/* Render Breadcrumbs */}

            <Row className="project-header mb20">
              <Col xs="6" lg="6">
                <ProjectDashboardBreadcrumb
                  title={this.props.t("Project")}
                  breadcrumbItem={this.props.t("Dashboard")}
                />
              </Col>

              <Col xs="6" lg="6">
               
                    <div className={`clearfix ${isResponsive ? 'mt-1 pt-1' : 'mt-2 pt-2'}`}>
                      {hasPermission("RealtorPreConsProjects", "Add") && (
                      <RsAdNewV2 to="#" onClick={this.toggleAddNew} className="float-end" iconClass="bx bx-plus-medical">Add new project</RsAdNewV2>
                      )}

                    </div>
                
              </Col>
            </Row>
            {isResponsive ? (
              <Card className="mt-4">
                <CardBody>
                  <Row className="text-center">
                    {reports.map((report, key) => (
                      <Col className="mb-2" key={key} xs={report.title == 'Leads to client conversion' ? 12 : 4}>
                        <div className="fw-bold fs-5" style={{ fontSize: 16 }}>{report.description}</div>
                        <div className="" style={{ fontSize: 16 }}>{report.title}</div>
                      </Col>
                    ))}
                  </Row>
                </CardBody>
              </Card>

            ) : (
              <div className="d-flex justify-content-center gap-3 flex-wrap bg-yellow">
                {reports.map((report, key) => (
                  <div key={key} className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(20% - 1rem)" }}>
                    <RsCardImgv4 title={report.title} description={report.description} iconClass={report.iconClass} isResponsive={isResponsive} />
                  </div>
                ))}
              </div>
            )}


            <Row className=" mt-4">
              <Col lg={4} className="d-flex mb-4">
                <Card className="border-full w-100">
                  <CardBody className="d-flex flex-column">
                    {barchartdata ? <RSBarChart title="Projects launches" filter={false} height="370" series={barchartdata.series} options={barchartdata.options} /> : " "}
                  </CardBody>
                </Card>
              </Col>
              <Col lg={4} className="d-flex mb-4">
                <Card className="border-full w-100">
                  <CardBody className="d-flex flex-column">
                    {CityBardata ? <RSBarChart title="Distribution by City" filter={false} height="370" series={CityBardata.series} options={CityBardata.options} /> : " "}
                  </CardBody>
                </Card>
              </Col>
              <Col lg={4} className="d-flex mb-4">
                <div className="card border-full w-100">
                  <div className="card-body d-flex flex-column">
                    <div className="card-title mb-4 float-start card-bottom-border">Top 5 Projects</div>
                    <Table
                      id=""
                      className="table table-striped table-bordered border-left-off"
                    >
                      <thead>
                        <tr>
                          <th>Project</th>
                          <th>City</th>
                          <th># Clients</th>
                          <th># Leads</th>
                        </tr>
                      </thead>
                      <tbody>
                        {projecttopfive.map((project, index) => (
                          <tr key={index}>
                            <td>{project.projectName}
                              <br />
                              {project.builderName}
                            </td>
                            <td>{project.city}</td>
                            <td> {project.noOfClient} </td>
                            <td>{project.noOfLead}</td>
                          </tr>
                        ))}


                      </tbody>
                    </Table>
                  </div>
                </div>
              </Col>
            </Row>



            <Row>
              <Col sm="6" className="d-flex mb-4">
                <Card className="border-full w-100">
                  <CardBody className="d-flex flex-column">

                    <div className="card-title card-bottom-border w-100" style={{ marginBottom: 10 }}>New leads

                      <span className="float-end">

                        {isResponsive ? (
                          <select
                            className="form-select"
                            value={activePeriod}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "Today") this.fetchNewLead(1, "Today");
                              if (value === "Yesterday") this.fetchNewLead(2, "Yesterday");
                              if (value === "Last 7 Days") this.fetchNewLead(7, "Last 7 Days");
                            }}
                          >
                            <option value="Today">Today</option>
                            <option value="Yesterday">Yesterday</option>
                            <option value="Last 7 Days">Last 7 Days</option>
                          </select>
                        ) : (
                          <Nav tabs className="float-end projectTab actTabs">
                            <NavItem>
                              <NavLink as={Link} to="#" active={activePeriod === 'Today'} onClick={() => this.fetchNewLead(1, 'Today')}>
                                Today
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink as={Link} to="#" active={activePeriod === 'Yesterday'} onClick={() => this.fetchNewLead(2, 'Yesterday')}>
                                Yesterday
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink as={Link} to="#" active={activePeriod === 'Last 7 Days'} onClick={() => this.fetchNewLead(7, 'Last 7 Days')}>
                                Last 7 Days
                              </NavLink>
                            </NavItem>
                          </Nav>

                        )}





                      </span>

                    </div>
                    <div className="clearfix"></div>
                    <div className="table-responsive" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                      <table className="table mb-0 table">
                        {isResponsive ? (
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Name</th>
                              <th>Email</th>

                              <th></th>

                            </tr>
                          </thead>
                        ) : (
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Project</th>
                              <th>Source</th>
                            </tr>
                          </thead>
                        )}

                      <tbody>
  {newLeads && newLeads.length > 0 ? (
    newLeads.map((data, prokey) => (
      <React.Fragment key={prokey}>
        <tr>
          <td>
            {data.addedDate ? (
              <Moment format="D MMM YY">{data.addedDate}</Moment>
            ) : (
              "-"
            )}
          </td>
          <td>{`${data.firstName || ""} ${data.lastName || ""}`.trim() || "-"}</td>
          <td>{data.email || "-"}</td>

          {/* For Desktop */}
          {!isResponsive && (
            <td>
              <Link to={`/pre-construction/campaign/current-prospects/${data.campaignProjectGuid}`}>
                {data.projectName || "-"}
              </Link>
            </td>
          )}

          {/* Last column (Responsive vs Desktop) */}
          {isResponsive ? (
            <td onClick={() => this.toggleLeadExpand(prokey)} style={{ cursor: "pointer" }}>
              {expandedLead === prokey ? "▲" : "▼"}
            </td>
          ) : (
            <td>
              {data.leadSourceId
                ? localization["LeadSource_" + data.leadSourceId]
                : "Manual"}
            </td>
          )}
        </tr>

        {/* Responsive Expanded Rows */}
        {isResponsive && expandedLead === prokey && (
          <>
            <tr className="bg-light">
              <td colSpan={5} className="p-2">
                <strong>Project:</strong> {data.projectName || "-"}
              </td>
            </tr>
            <tr className="bg-light">
              <td colSpan={5} className="p-2">
                <strong>Source:</strong>{" "}
                {data.leadSourceId
                  ? localization["LeadSource_" + data.leadSourceId]
                  : "Manual"}
              </td>
            </tr>
          </>
        )}
      </React.Fragment>
    ))
  ) : (
    <tr>
      <td
        colSpan={isResponsive ? "4" : "5"}
        className="text-center p-3 text-muted"
      >
        No data found
      </td>
    </tr>
  )}
</tbody>
                      </table>

                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col sm="6" className="d-flex">
                <Card className="border-full w-100">
                  <CardBody className="d-flex flex-column">
                    <h5 className="card-title card-bottom-border w-100" style={{ marginBottom: 10 }}>Follow Up Activity

                      <span className="float-end" >
                        {isResponsive ? (
                          <select
                            className="form-select"
                            value={activePeriod2}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "Today") this.fetchNewActivity(1, "Today");
                              if (value === "Tomorrow") this.fetchNewActivity(2, "Tomorrow");
                              if (value === "This Week") this.fetchNewActivity(7, "This Week");
                            }}
                          >
                            <option value="Today">Today</option>
                            <option value="Tomorrow">Tomorrow</option>
                            <option value="This Week">This Week</option>
                          </select>
                        ) : (
                          <Router>
                            <Nav tabs className="float-end projectTab actTabs">

                              <NavItem>
                                <NavLink as={Link} to="#" active={activePeriod2 === 'Today'} onClick={() => this.fetchNewActivity(1, 'Today')}>
                                  <span className="d-none d-sm-block">Today</span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink as={Link} to="#" active={activePeriod2 === 'Tomorrow'} onClick={() => this.fetchNewActivity(2, 'Tomorrow')}>
                                  <span className="d-none d-sm-block">Tomorrow</span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink as={Link} to="#" active={activePeriod2 === 'This Week'} onClick={() => this.fetchNewActivity(7, 'This Week')}>
                                  <span className="d-none d-sm-block">This Week</span>
                                </NavLink>
                              </NavItem>
                            </Nav>

                          </Router>
                        )}


                      </span>

                    </h5>
                    <div className="table-responsive" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                     <table className="table mb-0 table">
  {isResponsive ? (
    <thead>
      <tr>
        <th>Date</th>
        <th>Name</th>
        <th>Type</th>
        <th></th>
      </tr>
    </thead>
  ) : (
    <thead>
      <tr>
        <th>Date</th>
        <th>Name</th>
        <th>Type</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Project</th>
      </tr>
    </thead>
  )}

  <tbody>
    {newActivity && newActivity.length > 0 ? (
      newActivity.map((data, prokey) => (
        <React.Fragment key={prokey}>
          <tr>
            <td>
              {data.activityStartDate ? (
                <Moment format="D MMM YY">{data.activityStartDate}</Moment>
              ) : (
                "-"
              )}
            </td>
            <td>{data.contactName || "-"}</td>
            <td>
              {localization[
                "ActivitySubType_" +
                  data.activityType +
                  "_" +
                  data.activitySubType
              ] || "-"}
            </td>

            {isResponsive ? (
              <td
                onClick={() => this.toggleLeadActivity(prokey)}
                style={{ cursor: "pointer" }}
              >
                {expandedActivity === prokey ? "▲" : "▼"}
              </td>
            ) : (
              <>
                <td>{data.contactEmail || "-"}</td>
                <td>{data.contactPhone || "-"}</td>
                <td>{data.projectName || "-"}</td>
              </>
            )}
          </tr>

          {/* Responsive expanded section */}
          {isResponsive && expandedActivity === prokey && (
            <>
              <tr className="bg-light">
                <td colSpan={4} className="p-2">
                  <strong>Email:</strong> {data.contactEmail || "-"}
                </td>
              </tr>
              <tr className="bg-light">
                <td colSpan={4} className="p-2">
                  <strong>Phone:</strong> {data.contactPhone || "-"}
                </td>
              </tr>
              <tr className="bg-light">
                <td colSpan={4} className="p-2">
                  <strong>Project:</strong> {data.projectName || "-"}
                </td>
              </tr>
            </>
          )}
        </React.Fragment>
      ))
    ) : (
      <tr>
        <td
          colSpan={isResponsive ? "4" : "6"}
          className="text-center p-3 text-muted"
        >
          No data found
        </td>
      </tr>
    )}
  </tbody>
</table>

                    </div>
                  </CardBody>
                </Card>
              </Col>


            </Row>



            <Row>
              <Col lg="12">
                <Card className="border-full mt-4">
                  <CardHeader>
                    <div className="row">
                      <div className="col-sm-6  mb-2">
                        {/* <ProjectMenu />   */}
                        <div className="">
                          <div className="btn-group rl-group-btn" role="group">
                            <Link to="/pre-construction/my-project">
                              <button
                                type="button"
                                className={`btn btn-outline-secondary w-xs bt-filter-v2 active`}
                              >
                                <span className="d-flex align-items-center gap-2">
                                  Grid View

                                  <img src={gridView} style={{ height: 16 }} />
                                </span>
                              </button>
                            </Link>
                            <Link to="/pre-construction/compare-project">
                              <button
                                type="button"
                                className={`btn btn-outline-secondary w-xs bt-filter-v2`}
                              >

                                <span className="d-flex align-items-center gap-2">
                                  Compare Projects

                                  <img src={engagementView} style={{ height: 16 }} />
                                </span>
                              </button>
                            </Link>
                            {hasPermission("RealtorPreConsProjects", "Add") && (
                            <Link to="#" onClick={this.toggleAddNew}>
                              <button
                                type="button"
                                className={`btn btn-outline-secondary w-xs bt-filter-v2`}
                              >

                                <span className="d-flex align-items-center gap-2">
                                  Create Project

                                  <img src={plusIcon} style={{ height: 16 }} />
                                </span>
                              </button>
                            </Link>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-6 col-sm-2 mb-2">
                        <label className="visually-hidden" htmlFor="autoSizingSelect">Status</label>
                        <select name="status" className="form-select" value={selectedStatus} onChange={this.handleStatusFilter}>
                          <option value="0">All Project</option>
                          {/* <option value="0">All</option> */}
                          {map(docstatuses, (docstatus, classkey) => (

                            <option key={classkey} value={docstatus.id}>{docstatus.projectStatusTitle}</option>
                          ))}

                        </select>
                      </div>
                      <div className="col-6 col-sm-4    mb-2">
                        <div className="input-group">

                          <Input type="text" className="form-control search-bx" id="autoSizingInput"
                            value={searchQuery}
                            onChange={this.handleSearchChange}
                            placeholder="Search Project Name" />
                          {searchQuery && (
                            <button
                              className="btn btn-clear position-absolute"
                              style={{
                                right: "40px",
                                top: "48%",
                                transform: "translateY(-50%)",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                              }}
                              onClick={() => this.setState({ searchQuery: "" })}
                            >
                              ✖
                            </button>
                          )}
                          <span className="input-group-text search-btn" id="basic-addon1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody>



                    <div className="clearfix"></div>
                    {isResponsive ? (
                      <DataTable className="table"
                        stripedRows
                        value={filteredProjects}
                        paginator rows={10}
                        rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries "
                        paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        expandedRows={this.state.expandedRows}
                        onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                        rowExpansionTemplate={(rowData) => (
                          <table className="table table-sm mb-0 bg-light">
                            <tbody>
                              <tr>
                                <th># Leads</th>
                                <td>{rowData.noOfLeads}</td>
                              </tr>
                              <tr>
                                <th>Worksheet Pending</th>
                                <td>{rowData.noOfPendingWorksheets}</td>
                              </tr>
                              <tr>
                                <th>Worksheet Submitted</th>
                                <td>{rowData.noOFSubmittedWorkSheets}</td>
                              </tr>
                              <tr>
                                <th># Clients</th>
                                <td>{rowData.noOfClient}</td>
                              </tr>
                            </tbody>
                          </table>
                        )}

                      >
                        <Column expander style={{ width: "3rem" }} />
                        <Column
                          header="#"
                          body={(rowData, options) => options.rowIndex + 1}
                          style={{ width: '60px' }}
                        />
                        <Column field="lastContact" header="Project Name" body={(rowData) => (
                          <div>
                            <h5 className="text-truncate font-size-14">
                              <Link
                                to={"/pre-construction/project-detail/" + rowData.projectId}
                                className="text-dark"
                              >
                                {rowData.projectName}
                              </Link>
                            </h5>
                            <p className="text-muted mb-0">
                              {rowData.city}
                            </p>
                          </div>
                        )}></Column>




                        <Column field="lastContact" header="Action" body={(rowData) => (
                          <Link className="btn btn-action" to={"/pre-construction/campaign/" + rowData.preConsProjectGuid}>Manage Project</Link>

                        )}></Column>
                      </DataTable>
                    ) : (
                      <DataTable className="table"
                        stripedRows
                        value={filteredProjects}
                        paginator rows={10}
                        rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries "
                        paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        tableStyle={{ minWidth: '50rem' }}
                        headerColumnGroup={headerGroup}
                        filterDisplay="menu"
                      >
                        <Column
                          header="#"
                          body={(rowData, options) => options.rowIndex + 1}
                          style={{ width: '60px' }}
                        />
                        <Column field="lastContact" header="Project Name" body={(rowData) => (
                          <div>
                            <h5 className="text-truncate font-size-14">
                              <Link
                                to={"/pre-construction/project-detail/" + rowData.projectId}
                                className="text-dark"
                              >
                                {rowData.projectName}
                              </Link>
                            </h5>
                            <p className="text-muted mb-0">
                              {rowData.city}
                            </p>
                          </div>
                        )}></Column>

                        <Column field="lastContact" header="# Leads" body={(rowData) => (
                          rowData.noOfLeads
                        )}></Column>
                        {/* <Column field="lastContact" header="# Worksheets pending" body={(rowData) => (
                          rowData.noOfPendingWorksheets
                        )}></Column>
                        <Column field="lastContact" header="# Submitted Worksheets" body={(rowData) => (
                          rowData.noOFSubmittedWorkSheets
                        )}></Column> */}
                        <Column
                          field="noOfPendingWorksheets"
                          header="Pending"
                          headerClassName="text-center"
                          bodyClassName="text-center"
                          body={(rowData) => rowData.noOfPendingWorksheets}
                        ></Column>
                        <Column
                          field="noOFSubmittedWorkSheets"
                          header="Submitted"
                          headerClassName="text-center"
                          bodyClassName="text-center"
                          body={(rowData) => rowData.noOFSubmittedWorkSheets}
                        ></Column>

                        <Column field="lastContact" header="# Clients" body={(rowData) => (
                          rowData.noOfClient
                        )}></Column>

                        <Column field="projectStatus" header="Status"

                          body={(rowData) => (
                            <ProjectStatusGridOption
                              select={rowData.projectStatus}
                              docstatuses={docstatuses}
                              onStatusChange={(newStatus) => this.handleStatusChange(rowData.id, newStatus)}
                            />
                            // <Switch onColor="#50C878"  width={65}  uncheckedIcon={<Offsymbol />} checkedIcon={<OnSymbol />} onChange={isActive => this.handleChangeStaus(rowData)} checked={rowData.isActive} />
                          )}></Column>

                        <Column field="lastContact" header="Action" body={(rowData) => (
                          <Link className="btn btn-action" to={"/pre-construction/campaign/" + rowData.preConsProjectGuid}>Manage Project</Link>

                        )}></Column>
                      </DataTable>
                    )}
                    <div className="">


                    </div>
                  </CardBody>
                </Card>

              </Col>
            </Row>



          </Container>
        </div>


        <Offcanvas
          isOpen={this.state.isAddNew}
          direction="end"
          toggle={this.toggleAddNew}

        >
          <OffcanvasHeader toggle={this.toggleAddNew}>
            New Project
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                projectName: (this.state.projectName) ? this.state.projectName : '',

                projectType: "",
                projectStatus: "",
                projectBuilder: "",
                costPerSqFt: '',
                fullAddress: '',
                projectCurrencyCode: ''

                //projectLogoLink: (this.state.files.name) ?  this.state.files.name : ''

              }}
              validationSchema={Yup.object().shape({
                projectName: Yup.string().required("This is required"),
                projectType: Yup.string().required("This is required"),
                projectBuilder: Yup.string().required("This is required"),
                projectStatus: Yup.string().required("This is required"),
                projectCurrencyCode: Yup.string().required("This is required"),

              })}
              onSubmit={(values) => {
                this.props.addProject(values, (status) => {
                  if (status === true) {
                    this.toggleAddNew();
                  }
                });
              }}
            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="projectName">
                          {this.props.t("Project Name *")}
                        </Label>
                        <SafeField
                          name="projectName"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.projectName && touched.projectName
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="projectName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="builderName" className="w-100">
                          {this.props.t("Builder Name *")} <span className="float-end me-2"><Link to="#" onClick={this.toggleNewBuilder}>Add New</Link></span>
                        </Label>
                        <SafeField as="select" name="projectBuilder"
                          className={
                            "form-control" +
                            (errors.projectBuilder && touched.projectBuilder
                              ? " is-invalid"
                              : "")
                          }
                          onChange={handleChange}>
                          <option value="">Select</option>
                          {
                            this.state.builders
                              .map(builder =>
                                <option key={builder.id} value={builder.id}>{builder.builderName}</option>
                              )
                          }
                        </SafeField>
                        <ErrorMessage
                          name="projectBuilder"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="pType">
                          {this.props.t("Type *")}
                        </Label>
                        <SafeField as="select" name="projectType"
                          className={
                            "form-control" +
                            (errors.projectType && touched.projectType
                              ? " is-invalid"
                              : "")
                          }
                          onChange={handleChange}>
                          <option value="">Select</option>
                          {
                            this.state.projectTypes
                              .map(projectType =>
                                <option key={projectType.id} value={projectType.id}>{projectType.projectTypeTitle}</option>
                              )
                          }
                        </SafeField>
                        <ErrorMessage
                          name="projectType"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="fullAddress">
                          {this.props.t("Project Location")}
                        </Label>


                        <PlacesAutocomplete
                          value={values.fullAddress}
                          onChange={(value) => setFieldValue('fullAddress', value)}
                          onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                              <input
                                {...getInputProps({
                                  placeholder: 'Enter Address...',
                                  className: 'form-control',

                                })}
                              />
                              <div className="">
                                {loading ? <div>Loading...</div> : null}

                                {suggestions.map((suggestion, i) => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  const style = suggestion.active
                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                  return (
                                    <div
                                      key={i}
                                      {...getSuggestionItemProps(suggestion, {
                                        style,
                                      })}
                                    >
                                      {suggestion.description}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </FormGroup>
                    </Col>

                    <Col md="12">
                      <CurrencyDropdown name="projectCurrencyCode" label="Project Currency"
                        onCurrencyChange={this.handleCurrencyChange}
                      />
                    </Col>
                    <Col md="12">
                      <ProjectStatusOption name="projectStatus" errors={errors} touched={touched} />
                    </Col>
                  </Row>
                  <div>

                    <SaveButton>Save</SaveButton>



                  </div>
                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>



        <Offcanvas
          isOpen={this.state.isNewBuilder}
          direction="end"
          toggle={this.toggleNewBuilder}

        >
          <OffcanvasHeader toggle={this.toggleNewBuilder}>
            New Builder
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                builderName: (this.state && this.state.builderName) || "",
                agentId: parseInt(localStorage.getItem('userId')),
                builderLogoImage: '',
                fulladdress: '',
                longitude: '',
                latitude: '',



              }}
              validationSchema={Yup.object().shape({
                builderName: Yup.string().required("This is Required")
              })}

              onSubmit={this.handleValidSubmit}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="builderName">
                          {this.props.t("Builder Name *")}
                        </Label>
                        <SafeField
                          name="builderName"
                          onChange={handleChange}
                          type="text"
                          value={values.builderName}
                          className={
                            "form-control" +
                            (errors.builderName && touched.builderName
                              ? " is-invalid"
                              : "")
                          }
                          id="builderName"

                        />
                        <ErrorMessage
                          name="builderName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addressLine1">
                          {this.props.t("Location")}
                        </Label>
                        <PlacesAutocomplete
                          value={values.fullAddress}
                          onChange={(value) => setFieldValue('fullAddress', value)}
                          onSelect={(value) => this.handleBuilderPlaceSelected(value, setFieldValue)}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                              <input
                                {...getInputProps({
                                  placeholder: 'Enter Address...',
                                  className: 'form-control',

                                })}
                              />
                              <div className="">
                                {loading ? <div>Loading...</div> : null}

                                {suggestions.map((suggestion, i) => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  const style = suggestion.active
                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                  return (
                                    <div
                                      key={i}
                                      {...getSuggestionItemProps(suggestion, {
                                        style,
                                      })}
                                    >
                                      {suggestion.description}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>
                      </FormGroup>
                    </Col>



                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="builderLogo">
                          {this.props.t("Upload Logo")}
                        </Label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={event => this.handleFileChange(event, setFieldValue)}
                        />



                      </FormGroup>
                    </Col>



                  </Row>

                  <Row>

                    <div className="clearFix">
                      <SaveButton></SaveButton>
                    </div>
                  </Row>

                </Form>
              )}
            </Formik>

          </OffcanvasBody>
        </Offcanvas>

      </React.Fragment>
    )
  }
}

ProjectsList.propTypes = {

  className: PropTypes.any,
  t: PropTypes.any,
  history: PropTypes.object,
  projects: PropTypes.array,
  onGetAllProject: PropTypes.func,
  onDeleteProject: PropTypes.func,
  loading: PropTypes.object,
  setProjectSearchComplitionYear: PropTypes.func,
  setProjectSearchCity: PropTypes.func,
  onGetSearchAllProject: PropTypes.func,
  onUpdateStatus: PropTypes.func,
  docstatuses: PropTypes.array,
  onGetProjectStatus: PropTypes.func,
  addProject: PropTypes.func,
  isResponsive: PropTypes.object,
  addBuilder: PropTypes.func
}

const mapStateToProps = ({ Project, AppoinmentObject }) => ({
  projects: Project.projects,
  loading: Project.loading,
  docstatuses: AppoinmentObject.docstatuses
})

const mapDispatchToProps = dispatch => ({
  onGetAllProject: (agentId, brokerId) => dispatch(getAllProjectAction(agentId, brokerId)),
  onDeleteProject: (id) => dispatch(deleteProject(id)),
  onGetSearchAllProject: (data) => dispatch(getSearchAllProject(data)),
  onUpdateStatus: (data) => dispatch(updateProjectStatus(data)),
  onGetProjectStatus: (agentId) => dispatch(getProjectStatus(agentId)),
  addProject: (data, callback) => dispatch(addProject(data, callback)),
  addBuilder: (data, callback) => dispatch(addBuilder(data, callback)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(ProjectsList)))